import React, { useEffect, useState } from 'react'
import { getCityList, getCityWithTownList, deleteTown, postTown } from '../services/locations';
import { City, Town } from '../models/IOrders';

export default function AddTownPage() {
  const [cityList, setCityList]   = useState<City[]>();
  const [townList, setTownList]   = useState<City>();
  const [newTown, setNewTown]     = useState<Town>({ townNameTr: '', townNameEn: '', cityId: '', id: '' });
  const [search, setSearch]         = useState('');
  const [success, setSuccess]       = useState(false);
  const [loading, setLoading]       = useState(false);
  const [confirmTown, setConfirmTown] = useState<Town | null>(null);
  const [deleting, setDeleting]     = useState(false);

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      getCityList().then((response) => {
        if (response.data) setCityList(response.data);
      });
    }
  }, []);

  const handleCityChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCityId = evt.target.value;
    setNewTown(prev => ({ ...prev, cityId: selectedCityId }));
    setSearch('');
    getCityWithTownList(selectedCityId).then((response) => {
      if (response.data) setTownList(response.data);
    });
  };

  const AddTown = (event: React.FormEvent) => {
    event.preventDefault();
    if (!newTown.townNameTr || !newTown.cityId) return;
    setLoading(true);
    postTown(newTown)
      .then(() => {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
        // reload towns
        getCityWithTownList(newTown.cityId).then((r) => { if (r.data) setTownList(r.data); });
        setNewTown(prev => ({ ...prev, townNameTr: '', townNameEn: '' }));
        setSearch('');
      })
      .finally(() => setLoading(false));
  };

  const filteredTowns = townList?.town?.filter(t =>
    t.townNameTr.toLowerCase().includes(search.toLowerCase()) ||
    t.townNameEn.toLowerCase().includes(search.toLowerCase())
  ) ?? [];

  const isDuplicate = search.trim().length > 0 &&
    townList?.town?.some(t =>
      t.townNameTr.toLowerCase() === search.trim().toLowerCase() ||
      t.townNameEn.toLowerCase() === search.trim().toLowerCase()
    );

  const selectedCity = cityList?.find(c => c.id === newTown.cityId);

  const handleDelete = () => {
    if (!confirmTown?.id) return;
    setDeleting(true);
    deleteTown(confirmTown.id)
      .then(() => {
        setConfirmTown(null);
        getCityWithTownList(newTown.cityId).then((r) => { if (r.data) setTownList(r.data); });
      })
      .finally(() => setDeleting(false));
  };

  return (
    <div className="at-page">

      {/* Page header */}
      <div className="at-page-header">
        <div className="at-page-title-group">
          <div className="at-page-icon">
            <i className="bi bi-signpost-2-fill"></i>
          </div>
          <div>
            <h4 className="at-page-title">Kent Ekle</h4>
            <p className="at-page-subtitle">Şehire bağlı yeni kent tanımla</p>
          </div>
        </div>
      </div>

      <div className="at-layout">

        {/* ── Left: Form ── */}
        <div className="at-card">
          <div className="at-card-header">
            <i className="bi bi-plus-circle-fill me-2"></i>Yeni Kent
          </div>
          <div className="at-card-body">
            <form onSubmit={AddTown}>

              {/* Şehir seç */}
              <div className="at-field">
                <label className="at-label">
                  <i className="bi bi-map-fill me-1"></i>Şehir
                </label>
                <select
                  className="form-select at-select"
                  value={newTown.cityId}
                  onChange={handleCityChange}
                  required
                >
                  <option value="" disabled>Şehir seçin...</option>
                  {cityList?.map((city) => (
                    <option key={city.id} value={city.id}>{city.cityNameTr}</option>
                  ))}
                </select>
              </div>

              {/* Kent adı TR */}
              <div className="at-field">
                <label className="at-label">
                  <i className="bi bi-translate me-1"></i>Kent Adı (TR)
                </label>
                <input
                  type="text"
                  className="form-control at-input"
                  placeholder="örn: Kadıköy"
                  value={newTown.townNameTr}
                  onChange={(e) => setNewTown(prev => ({ ...prev, townNameTr: e.target.value }))}
                  required
                />
              </div>

              {/* Kent adı EN */}
              <div className="at-field">
                <label className="at-label">
                  <i className="bi bi-translate me-1"></i>Kent Adı (EN)
                </label>
                <input
                  type="text"
                  className="form-control at-input"
                  placeholder="örn: Kadikoy"
                  value={newTown.townNameEn}
                  onChange={(e) => setNewTown(prev => ({ ...prev, townNameEn: e.target.value }))}
                  required
                />
              </div>

              {success && (
                <div className="at-alert at-alert--success">
                  <i className="bi bi-check-circle-fill me-2"></i>Kent başarıyla eklendi!
                </div>
              )}

              <button type="submit" className="at-btn-submit" disabled={loading}>
                {loading
                  ? <><span className="spinner-border spinner-border-sm me-2"></span>Ekleniyor...</>
                  : <><i className="bi bi-plus-lg me-2"></i>Kent Ekle</>
                }
              </button>

            </form>
          </div>
        </div>

        {/* ── Right: Town list ── */}
        <div className="at-card">
          <div className="at-card-header">
            <i className="bi bi-list-ul me-2"></i>
            {selectedCity ? `${selectedCity.cityNameTr} — Mevcut Kentler` : 'Mevcut Kentler'}
            {townList?.town && (
              <span className="at-badge ms-2">{townList.town.length}</span>
            )}
          </div>
          <div className="at-card-body">

            {!townList ? (
              <div className="at-empty">
                <i className="bi bi-arrow-left-circle"></i>
                <p>Listeyi görmek için şehir seçin</p>
              </div>
            ) : (
              <>
                {/* Search */}
                <div className="at-search-wrap">
                  <i className="bi bi-search at-search-icon"></i>
                  <input
                    type="text"
                    className="form-control at-search-input"
                    placeholder="Kent ara..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  {search && (
                    <button className="at-search-clear" onClick={() => setSearch('')}>
                      <i className="bi bi-x-lg"></i>
                    </button>
                  )}
                </div>

                {/* Duplicate warning */}
                {isDuplicate && (
                  <div className="at-alert at-alert--warning">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Bu isimde bir kent zaten mevcut!
                  </div>
                )}

                {/* No results */}
                {search && !isDuplicate && filteredTowns.length === 0 && (
                  <div className="at-alert at-alert--info">
                    <i className="bi bi-info-circle-fill me-2"></i>
                    "<strong>{search}</strong>" ile eşleşen kent bulunamadı — ekleyebilirsiniz.
                  </div>
                )}

                {/* Town list */}
                <div className="at-town-list">
                  {filteredTowns.map((town) => (
                    <div key={town.id} className="at-town-item">
                      <div className="at-town-dot"></div>
                      <div className="at-town-names">
                        <span className="at-town-tr">{town.townNameTr}</span>
                        <span className="at-town-en">{town.townNameEn}</span>
                      </div>
                      <button
                        className="at-town-delete"
                        title="Kenti sil"
                        onClick={() => setConfirmTown(town)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>
                  ))}
                </div>

                {!search && filteredTowns.length === 0 && (
                  <div className="at-empty">
                    <i className="bi bi-geo"></i>
                    <p>Bu şehire henüz kent eklenmemiş</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

      </div>
      {/* Confirm delete modal */}
      {confirmTown && (
        <div className="at-modal-backdrop" onClick={() => setConfirmTown(null)}>
          <div className="at-modal" onClick={(e) => e.stopPropagation()}>
            <div className="at-modal-icon">
              <i className="bi bi-trash3-fill"></i>
            </div>
            <h5 className="at-modal-title">Kenti Sil</h5>
            <p className="at-modal-desc">
              <strong>{confirmTown.townNameTr}</strong> kentini silmek istediğinizden emin misiniz?
              Bu işlem geri alınamaz.
            </p>
            <div className="at-modal-actions">
              <button className="at-modal-btn at-modal-btn--cancel" onClick={() => setConfirmTown(null)} disabled={deleting}>
                Vazgeç
              </button>
              <button className="at-modal-btn at-modal-btn--delete" onClick={handleDelete} disabled={deleting}>
                {deleting
                  ? <><span className="spinner-border spinner-border-sm me-2"></span>Siliniyor...</>
                  : <><i className="bi bi-trash3 me-2"></i>Evet, Sil</>
                }
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
